module.exports = __webpack_public_path__ + "img/menu3.25ea3cf1.png";